import ScalarIconList_vue_vue_type_script_setup_true_lang_default from "./ScalarIconList.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconList.vue
var ScalarIconList_default = ScalarIconList_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconList_default as default };

//# sourceMappingURL=ScalarIconList.js.map